import { HttpResult } from 'widgets-for-react'
import { filtersToQueryParams, NewsAndEventsFilters } from '../../utils/filtersToQueryParams'
import { NewsOrEventData, transformNewsOrEventData } from '../cmsPage/blocks/block/relatedContentBlock/relatedContentBlockApi'
import { NewsOrEvent } from '../cmsPage/blocks/block/relatedContentBlock/relatedContentBlockState'

export const getEventOverviewItems = async (
  filters: NewsAndEventsFilters,
  page: number
): Promise<HttpResult<NewsOrEvent[]>> => {
  const res = await fetch(`/api/v1/pages/events/filter?${filtersToQueryParams(filters)}&page=${page - 1}`)

  if (!res.ok)
    return {
      kind: 'failed',
      status: res.status,
    }

  const data: NewsOrEventData = await res.json()

  return {
    kind: 'result',
    status: 200,
    value: transformNewsOrEventData(data),
  }
}
